import auth from "../middlewares/auth";
export const lecture = [
    {
        path: '/lecture',
        component: () => import(/* webpackChunkName: "lecture" */ '../views/lecture/Index'),
        name: 'lecture',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/lecture/add',
        component: () => import(/* webpackChunkName: "lecture" */ '../views/lecture/Form'),
        name: 'lecture_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/lecture/edit/:id',
        component: () => import(/* webpackChunkName: "lecture" */ '../views/lecture/Form'),
        name: 'lecture_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
